export default __webpack_public_path__ + "static/media/flv.0959fcf8.svg";